define("media/components/media/bulk-labels", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/lib/filter-by-fields", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _service, _utils, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _filterByFields, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/lib/filter-by-fields",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{perform this.closeBulkLabelAdd}} {{did-insert this.clearLabelsToAdd}} as |modal|>
    <modal.card @portrait={{true}}>
  
      <modal.card-body class="u--p__0">
  
        <div class="cLB--section--left">
  
          <h3 class="o--modalHeader__title u--m__b__md">{{t "media_library.labels.apply_labels"}}</h3>
  
          {{!  Search Container }}
          <div class="o--formWrapper">
            <div class="o--inputAction u--p__r__xs">
              {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
              <Input
                @type="search"
                @value={{this.labelSearchString}}
                class="o--inputAction__input eLS--input"
                placeholder={{t "media_library.labels.search_labels"}}
              />
              {{#if this.isSearchingLabels}}
                <span {{on "click" this.clearLabelSearch}}>
                  {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
                </span>
              {{/if}}
            </div>
          </div>
  
          <div class="cLB--section__scrollContainer eLB--bulk__scrollContainer" {{perfect-scroll}}>
            {{!  Add Label }}
            <div class="o--formWrapper u--m__b__xs">
              <div class="o--inputAction--light u--p__l">
                <Input
                  @enter={{this.addNewLabel}}
                  @type="text"
                  @value={{this.newLabel}}
                  class="o--inputAction__input"
                  placeholder={{t "media_library.labels.add_new_label"}}
                />
                <span {{on "click" this.addNewLabel}}>
                  {{svg-jar "add-circle" class="o--icon o--inputAction__icon--right u--text--hl"}}
                </span>
              </div>
            </div>
  
            {{#each this.filteredGroupLabels as |groupLabel|}}
              <Media::BulkLabelItem
                @label={{groupLabel}}
                @selectedLabels={{this.labelsToAdd}}
                @updateLabel={{this.updateLabel}}
              />
            {{/each}}
  
          </div>
        </div>
  
        {{!  Selected Labels }}
        <div class="cLB--section--right">
          <div>
            <label>
              {{t "media_library.labels.selected_labels"}}
            </label>
            {{#if this.hasSelectedLabels}}
              <Shared::Ui::Button
                @class="u--m__l__xs u--text--sm u--text--uppercase u--float--right u--text--hl"
                @onClick={{this.clearLabelsToAdd}}
                @text={{t "media_library.labels.clear_all"}}
                @variant="unstyled"
              />
            {{/if}}
  
            {{!Label Collection}}
            <div class="cLB--labelWrapper">
              {{#each this.labelsToAdd as |labelToAdd|}}
                <span class="cLB--label--sm">
                  <span class="cLB--label__text">{{labelToAdd.canonicalTagName}}</span>
                  <span {{on "click" (fn this.updateLabel labelToAdd)}}>
                    {{svg-jar "close" class="o--icon--sm o--icon--light cLB--label__icon"}}
                  </span>
                </span>
              {{/each}}
            </div>
          </div>
        </div>
  
      </modal.card-body>
  
      <modal.card-footer class="u--p__lr">
        <Shared::Ui::Button
          @isDisabled={{not this.hasSelectedLabels}}
          @onClick={{this.applyBulkLabels}}
          @text={{t "media_items.labels.apply_labels"}}
          class="u--float--right"
        />
      </modal.card-footer>
  
    </modal.card>
  
  </Shared::Modal>
  */
  {
    "id": "rugRgceA",
    "block": "[[[8,[39,0],[[4,[38,2],[[30,0,[\"clearLabelsToAdd\"]]],null]],[[\"@close\"],[[28,[37,1],[[30,0,[\"closeBulkLabelAdd\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__0\"]],null,[[\"default\"],[[[[1,\"\\n\\n      \"],[10,0],[14,0,\"cLB--section--left\"],[12],[1,\"\\n\\n        \"],[10,\"h3\"],[14,0,\"o--modalHeader__title u--m__b__md\"],[12],[1,[28,[35,3],[\"media_library.labels.apply_labels\"],null]],[13],[1,\"\\n\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--inputAction u--p__r__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n            \"],[8,[39,5],[[24,0,\"o--inputAction__input eLS--input\"],[16,\"placeholder\",[28,[37,3],[\"media_library.labels.search_labels\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"labelSearchString\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"isSearchingLabels\"]],[[[1,\"              \"],[11,1],[4,[38,7],[\"click\",[30,0,[\"clearLabelSearch\"]]],null],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[11,0],[24,0,\"cLB--section__scrollContainer eLB--bulk__scrollContainer\"],[4,[38,8],null,null],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"o--formWrapper u--m__b__xs\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--inputAction--light u--p__l\"],[12],[1,\"\\n              \"],[8,[39,5],[[24,0,\"o--inputAction__input\"],[16,\"placeholder\",[28,[37,3],[\"media_library.labels.add_new_label\"],null]]],[[\"@enter\",\"@type\",\"@value\"],[[30,0,[\"addNewLabel\"]],\"text\",[30,0,[\"newLabel\"]]]],null],[1,\"\\n              \"],[11,1],[4,[38,7],[\"click\",[30,0,[\"addNewLabel\"]]],null],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"add-circle\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--text--hl\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"filteredGroupLabels\"]]],null]],null],null,[[[1,\"            \"],[8,[39,11],null,[[\"@label\",\"@selectedLabels\",\"@updateLabel\"],[[30,2],[30,0,[\"labelsToAdd\"]],[30,0,[\"updateLabel\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[10,0],[14,0,\"cLB--section--right\"],[12],[1,\"\\n        \"],[10,0],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"media_library.labels.selected_labels\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasSelectedLabels\"]],[[[1,\"            \"],[8,[39,12],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--m__l__xs u--text--sm u--text--uppercase u--float--right u--text--hl\",[30,0,[\"clearLabelsToAdd\"]],[28,[37,3],[\"media_library.labels.clear_all\"],null],\"unstyled\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"cLB--labelWrapper\"],[12],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"labelsToAdd\"]]],null]],null],null,[[[1,\"              \"],[10,1],[14,0,\"cLB--label--sm\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"cLB--label__text\"],[12],[1,[30,3,[\"canonicalTagName\"]]],[13],[1,\"\\n                \"],[11,1],[4,[38,7],[\"click\",[28,[37,13],[[30,0,[\"updateLabel\"]],[30,3]],null]],null],[12],[1,\"\\n                  \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon--sm o--icon--light cLB--label__icon\"]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[3]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-footer\"]],[[24,0,\"u--p__lr\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,12],[[24,0,\"u--float--right\"]],[[\"@isDisabled\",\"@onClick\",\"@text\"],[[28,[37,14],[[30,0,[\"hasSelectedLabels\"]]],null],[30,0,[\"applyBulkLabels\"]],[28,[37,3],[\"media_items.labels.apply_labels\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\\n\"]],[1]]]]]],[\"modal\",\"groupLabel\",\"labelToAdd\"],false,[\"shared/modal\",\"perform\",\"did-insert\",\"t\",\"svg-jar\",\"input\",\"if\",\"on\",\"perfect-scroll\",\"each\",\"-track-array\",\"media/bulk-label-item\",\"shared/ui/button\",\"fn\",\"not\"]]",
    "moduleName": "media/components/media/bulk-labels.hbs",
    "isStrictMode": false
  });
  let BulkLabelsComponent = _exports.default = (_dec = (0, _computed.sort)('nonSystemLabels', 'labelSorting'), (_class = class BulkLabelsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "labelsToAdd", _descriptor3, this);
      _initializerDefineProperty(this, "labelSearchString", _descriptor4, this);
      _initializerDefineProperty(this, "newLabel", _descriptor5, this);
      _initializerDefineProperty(this, "sortedNonSystemLabels", _descriptor6, this);
      _defineProperty(this, "labelSorting", ['taggedCount:desc']);
      _defineProperty(this, "closeBulkLabelAdd", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.hasSelectedLabels) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('shared_phrases.close_warning'), {
              description: this.intl.t('shared_phrases.changes_not_saved'),
              confirmButton: this.intl.t('shared_words.leave')
            });
            if (!didConfirm) {
              return;
            }
          }
          this.args.closeBulkLabelAdd();
        }
      }), null, "closeBulkLabelAdd", null));
      this.labelsToAdd = new _trackedBuiltIns.TrackedArray([]);
      this.labelSearchString = undefined;
      this.newLabel = null;
    }
    get filteredGroupLabels() {
      if ((0, _utils.isEmpty)(this.labelSearchString)) {
        return this.sortedNonSystemLabels;
      }
      const filteredLabels = (0, _filterByFields.default)(this.sortedNonSystemLabels, ['tagName'], this.labelSearchString);
      return new _trackedBuiltIns.TrackedArray(filteredLabels);
    }
    get hasSelectedLabels() {
      return !(0, _utils.isEmpty)(this.labelsToAdd);
    }
    get isSearchingLabels() {
      return !(0, _utils.isEmpty)(this.labelSearchString);
    }
    get nonSystemLabels() {
      return new _trackedBuiltIns.TrackedArray(this.args.groupLabels.filter(label => label.isSystemLabel === false));
    }
    addNewLabel() {
      if (typeof this.newLabel === 'string' && !(0, _utils.isEmpty)(this.newLabel)) {
        this.args.addNewLabel(this.newLabel, this.labelsToAdd);
      }
      this.newLabel = null;
    }
    applyBulkLabels() {
      this.args.applyBulkLabels(this.labelsToAdd);
    }
    clearLabelSearch() {
      this.labelSearchString = undefined;
    }
    clearLabelsToAdd() {
      this.labelsToAdd = new _trackedBuiltIns.TrackedArray([]);
    }
    updateLabel(label) {
      this.labelsToAdd.includes(label) ? this.labelsToAdd.removeObject(label) : this.labelsToAdd.addObject(label);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "labelsToAdd", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelSearchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "newLabel", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sortedNonSystemLabels", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addNewLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyBulkLabels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "applyBulkLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearLabelSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearLabelSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearLabelsToAdd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearLabelsToAdd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateLabel"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BulkLabelsComponent);
});